module.exports = __webpack_public_path__ + "img/d1.68b09ae1.png";